import { render, staticRenderFns } from "./userManager.vue?vue&type=template&id=5c0a5856&scoped=true&"
import script from "./userManager.vue?vue&type=script&lang=js&"
export * from "./userManager.vue?vue&type=script&lang=js&"
import style0 from "./userManager.vue?vue&type=style&index=0&id=5c0a5856&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0a5856",
  null
  
)

export default component.exports